/* Copyright (c) 2025 MOCA Systems, Inc. All rights reserved. */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { PlanPrintSettingsComponent } from 'src/app/modules/plan-print-settings/plan-print-settings.component';
import { PlanPrintPanelRemoteControlService } from 'src/app/services/plan-print-panel-remote-control.service';
import { PlanPrintService } from 'src/app/modules/plan/services/plan-print.service';
import { PlanTicketsFilterRemoteControlService } from 'src/app/services/plan-tickets-filter-remote-control.service';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import * as appStrings from '@touchplan/strings';

const COMPONENTS = [PlanPrintSettingsComponent, MatIconModule, MatButtonModule];
const MODULES = [CommonModule];

@Component({
	standalone: true,
	selector: 'tp-plan-print-panel',
	templateUrl: './plan-print-panel.component.html',
	styleUrls: ['./plan-print-panel.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [...MODULES, ...COMPONENTS, MatDividerModule],
	providers: [],
})
export class PlanPrintPanelComponent {
	protected appStrings = appStrings;
	protected collapsed = false;
	protected planPrintPanelRemoteControlService = inject(PlanPrintPanelRemoteControlService);
	private planPrintService = inject(PlanPrintService);
	private planTicketsFilterRemoteControlService = inject(PlanTicketsFilterRemoteControlService);

	constructor() {}

	protected toggleCollapse(): void {
		this.collapsed = !this.collapsed;
	}

	protected onOpenPlanFilter(): void {
		this.planPrintService.closeView();
		this.planPrintPanelRemoteControlService.closePrintPlantSettingsControl();
		this.planTicketsFilterRemoteControlService.openPlanTicketsFilter();
	}

	protected onClose(): void {
		this.planPrintPanelRemoteControlService.closePrintPlantSettingsControl();
		this.planPrintService.closeView();
	}
}
